<template>
  <div class="vue-template">
    <MenuHome />

    <HeadPagina />

    <ContentPagina />

    <QuestionsProductNowNow/> 

    <!---------- FOOTER ------------->
    <Footer />
  </div>
</template>

<script>
import MenuHome from "@/components/Home/MenuHome";
import HeadPagina from "@/components/ProductNowNow/HeadPagina";
import ContentPagina from "@/components/ProductNowNow/ContentPagina";
import QuestionsProductNowNow from "@/components/ProductNowNow/QuestionsProductNowNow";
import Footer from "@/components/Home/Footer";

export default {
  components: { MenuHome, HeadPagina, ContentPagina, QuestionsProductNowNow, Footer },
  name: "Home",
  metaInfo() {
    return {
      title: this.$t("Home.Main.metaTag.title"),
      meta: [
        {
          name: "description",
          content: this.$t("Home.Main.metaTag.description"),
        },
        {
          name: "description",
          content: this.$t("Home.Main.metaTag.description"),
        },
      ],
    };
  },
};
</script>

<style>
.v-application--wrap,
#app,
html {
  width: 100% !important;
  height: 100% !important;
  background-color: #ffffff;
}

.phone-model {
  margin: 10px auto 0px;
}

@media (max-width: 500px) {
  .phone-model {
    max-width: 90% !important;
  }

  .container-head {
    font-size: 20px !important;
    width: 85%;
  }

  .btn-text {
    font-size: 12px !important;
  }
}
</style>